export const ThemePresetData = [
  {
    title: 'default',
    author: 'Kilohearts',
    data: {
      window_background: "1e222a",
      main_background: "454341",
      panel_background: "333130",
      control_background: "282625",
      foreground: "898989",
      text: "acacac",
      knob: "333130",
      unimportant_text: "797876",
      passive: "6a6968",
      active: "6a9dea",
      modulation: "ff8020",
      audio_rate_modulation: "71c742",
      aux_modulation: "dcc959",
      modulation_background: "000000",
      alert: "bf312e",
      encoder: "5c5b5b",
      handle: "cacaca",
      mute: "ab211e",
      solo: "2f861a",
      left: "61b264",
      right: "b460ae",
      mid: "437ddd",
      side: "d79e4f",
      selection_background: "3c4a60",
      selection_foreground: "eeeeee",
      grid_major: "434140",
      grid_minor: "353332",
      disabled_tint: "888888",
      phase_plant_backdrop: "",
      phase_plant_backdrop_alpha: "1.0",
      multipass_backdrop: "",
      multipass_backdrop_alpha: "1.0",
      snap_heap_backdrop: "",
      snap_heap_backdrop_alpha: "1.0"
    }
  },
  {
    title: 'Beeplant',
    author: 'metchadnb',
    data: {
      window_background: "202024",
      main_background: "2d2e34",
      panel_background: "222225",
      control_background: "201f23",
      foreground: "575b64",
      text: "d4d4d4",
      knob: "1f2327",
      unimportant_text: "777b82",
      passive: "393b40",
      active: "fbb64b",
      modulation: "319fb0",
      audio_rate_modulation: "b8e986",
      aux_modulation: "dcc959",
      modulation_background: "202024",
      alert: "fc4351",
      encoder: "393b40",
      handle: "d4d4d4",
      mute: "fc4351",
      solo: "b8e986",
      left: "61b264",
      right: "b460ae",
      mid: "437ddd",
      side: "d79e4f",
      selection_background: "3d4047",
      selection_foreground: "d4d4d4",
      grid_major: "3d4047",
      grid_minor: "26282d",
      disabled_tint: "8996a3",
      phase_plant_backdrop: "",
      phase_plant_backdrop_alpha: "1.0",
      multipass_backdrop: "",
      multipass_backdrop_alpha: "1.0",
      snap_heap_backdrop: "",
      snap_heap_backdrop_alpha: "1.0"
    }
  },
  {
    title: 'untitled 1',
    author: "reaver",
    data: {
      window_background: "1f2025",
      main_background: "2c2e36",
      panel_background: "26272c",
      control_background: "232529",
      foreground: "dbdbdb",
      text: "e8eaef",
      unimportant_text: "777b82",
      passive: "62656e",
      active: "b4c0e2",
      modulation: "5796f3",
      audio_rate_modulation: "fe733d",
      aux_modulation: "ffffff",
      alert: "5796f3",
      encoder: "858b8b",
      handle: "d4d4d4",
      mute: "5796f3",
      solo: "d4d4d4",
      left: "fe733d",
      right: "4486ab",
      mid: "70adff",
      side: "ffffff",
      selection_background: "3d4047",
      selection_foreground: "d4d4d4",
      disabled_tint: "979ba9",
      knob: "1e2024",
      modulation_background: "202024",
      grid_major: "3d4047",
      grid_minor: "26282d",
      phase_plant_backdrop: "Phase_Plant.png",
      phase_plant_backdrop_alpha: "0",
      multipass_backdrop: "Multipass.png",
      multipass_backdrop_alpha: "0",
      snap_heap_backdrop: "Snap_Heap.png",
      snap_heap_backdrop_alpha: "0"
    }
  },
  {
    title: 'Default Dimmed',
    author: 'sanjaux',
    data: {
      window_background: "1b1c1e",
      main_background: "2d2e30",
      panel_background: "222324",
      control_background: "1b1c1e",
      foreground: "595a5c",
      text: "616264",
      unimportant_text: "4e4f50",
      passive: "464748",
      active: "828c9a",
      modulation: "a47b5c",
      audio_rate_modulation: "6b8262",
      aux_modulation: "8d8a76",
      alert: "7b5253",
      encoder: "3c3d3e",
      handle: "828384",
      mute: "6f4344",
      solo: "3c5937",
      left: "6e7570",
      right: "756f77",
      mid: "667792",
      side: "8a7f6e",
      selection_background: "3f4042",
      selection_foreground: "999a9b",
      disabled_tint: "57595a",
      knob: "222324",
      modulation_background: "010204",
      grid_major: "2b2c2e",
      grid_minor: "242526",
      phase_plant_backdrop: "Phase_Plant.png",
      phase_plant_backdrop_alpha: "0",
      multipass_backdrop: "Multipass.png",
      multipass_backdrop_alpha: "0",
      snap_heap_backdrop: "Snap_Heap.png",
      snap_heap_backdrop_alpha: "0"
    },
  },
  {
    title: 'Seaweed',
    author: 'sanjaux',
    data: {
      window_background: "222629",
      main_background: "282d30",
      panel_background: "222629",
      control_background: "1c1f21",
      foreground: "418191",
      text: "a0b0ae",
      unimportant_text: "5f706b",
      passive: "5d6b6a",
      active: "306369",
      modulation: "88c1c2",
      audio_rate_modulation: "7e7ec4",
      aux_modulation: "cc918b",
      alert: "bf302e",
      encoder: "31363b",
      handle: "abd6d4",
      mute: "ab4846",
      solo: "5b8750",
      left: "60b363",
      right: "b560af",
      mid: "437ede",
      side: "d69e4f",
      selection_background: "8e9c99",
      selection_foreground: "434f4f",
      disabled_tint: "445d5e",
      knob: "323c40",
      modulation_background: "000000",
      grid_major: "93b8b6",
      grid_minor: "293333",
      phase_plant_backdrop: "Phase_Plant.png",
      phase_plant_backdrop_alpha: "0",
      multipass_backdrop: "Multipass.png",
      multipass_backdrop_alpha: "0",
      snap_heap_backdrop: "Snap_Heap.png",
      snap_heap_backdrop_alpha: "0"
    }
  },
  {
    title: 'Vital skin port',
    author: 'Alex Glimmer',
    data: {
      window_background: "24282c",
      main_background: "1c1e21",
      panel_background: "282b2f",
      control_background: "141719",
      foreground: "777e85",
      text: "c5d4ff",
      knob: "303033",
      unimportant_text: "848488",
      passive: "6a6968",
      active: "c5d4ff",
      modulation: "ff4d4d",
      audio_rate_modulation: "5a88fc",
      aux_modulation: "40ff4e",
      modulation_background: "000000",
      alert: "ff4d4d",
      encoder: "56565d",
      handle: "ff4d4d",
      mute: "ff4d4d",
      solo: "c5d4ff",
      left: "61b264",
      right: "fc69d9",
      mid: "437ddd",
      side: "ff4d4d",
      selection_background: "3c4a60",
      selection_foreground: "eeeeee",
      grid_major: "434140",
      grid_minor: "353332",
      disabled_tint: "7d7e7e",
      phase_plant_backdrop: "",
      phase_plant_backdrop_alpha: "1.0",
      multipass_backdrop: "",
      multipass_backdrop_alpha: "1.0",
      snap_heap_backdrop: "",
      snap_heap_backdrop_alpha: "1.0"
    }
  },
  {
    title: 'Raspberry',
    author: 'sanjaux',
    data: {
      window_background: "292929",
      main_background: "421b27",
      panel_background: "33151e",
      control_background: "33151e",
      foreground: "dbdbdb",
      text: "fcfcfc",
      unimportant_text: "757575",
      passive: "8a8e99",
      active: "f7f7f7",
      modulation: "fab57f",
      audio_rate_modulation: "9dc28a",
      aux_modulation: "d6cfa7",
      alert: "ba7573",
      encoder: "595959",
      handle: "c4c4c4",
      mute: "a85f5e",
      solo: "58854c",
      left: "a2b0a3",
      right: "b0a0af",
      mid: "93aed9",
      side: "d1ba9d",
      selection_background: "5d5e5e",
      selection_foreground: "e8e8e8",
      disabled_tint: "858585",
      knob: "333333",
      modulation_background: "000000",
      grid_major: "722e41",
      grid_minor: "722e41"
    }
  },
  {
    title: 'Anthracite Jade',
    author: 'AbitraryRage',
    data: {
      window_background: "1e222a",
      main_background: "1c242b",
      panel_background: "0b1014",
      control_background: "0b1014",
      foreground: "387d71",
      text: "bec2c7",
      knob: "1c242b",
      unimportant_text: "79838b",
      passive: "5a636b",
      active: "387d71",
      modulation: "ff8744",
      audio_rate_modulation: "84ee19",
      aux_modulation: "fdde43",
      modulation_background: "000000",
      alert: "bf312e",
      encoder: "3e474f",
      handle: "3c454d",
      mute: "ff4444",
      solo: "84ee19",
      left: "61b264",
      right: "b460ae",
      mid: "437ddd",
      side: "d79e4f",
      selection_background: "1a3433",
      selection_foreground: "368866",
      grid_major: "434140",
      grid_minor: "353332",
      disabled_tint: "7f7f7f",
      phase_plant_backdrop: "",
      phase_plant_backdrop_alpha: "1.0",
      multipass_backdrop: "",
      multipass_backdrop_alpha: "1.0",
      snap_heap_backdrop: "",
      snap_heap_backdrop_alpha: "1.0"
    }
  },
  {
    title: 'spotify',
    author: '5 Steps',
    data: {
      window_background: "121212",
      main_background: "292929",
      panel_background: "171717",
      control_background: "121212",
      foreground: "707070",
      text: "8f8f8f",
      unimportant_text: "616161",
      passive: "545454",
      active: "1eba55",
      modulation: "1cc3e8",
      audio_rate_modulation: "f073f0",
      aux_modulation: "fcaf14",
      alert: "cc1d1d",
      encoder: "4a4a4a",
      handle: "c2c2c2",
      mute: "cc1d1d",
      solo: "1eba55",
      left: "de981f",
      right: "1cc3e8",
      mid: "1eba55",
      side: "b041a7",
      selection_background: "1eba55",
      selection_foreground: "121212",
      disabled_tint: "707070",
      knob: "171717",
      modulation_background: "121212",
      grid_major: "363236",
      grid_minor: "2a282b",
      phase_plant_backdrop: "Phase_Plant.png",
      phase_plant_backdrop_alpha: "0",
      multipass_backdrop: "Multipass.png",
      multipass_backdrop_alpha: "0",
      snap_heap_backdrop: "Snap_Heap.png",
      snap_heap_backdrop_alpha: "0"
    }

  }
]